import { defineMessages } from 'react-intl.macro';

export const messages = defineMessages({
    headerLabel: {
        id: 'removeStudentModal.headerLabel',
        defaultMessage: 'Remove student from roster',
    },
    closeModalButtonLabel: {
        id: 'removeStudentModal.closeModalButtonLabel',
        defaultMessage: 'Remove from roster',
    },
    closeModalButtonText: {
        id: 'removeStudentModal.closeModalButtonText',
        defaultMessage: 'Cancel',
    },
    removeStudentModalButtonText: {
        id: 'removeStudentModal.removeStudentModalButtonText',
        defaultMessage: 'Remove',
    },
    removeStudentModalBody: {
        id: 'removeStudentModal.removeStudentModalBody',
        defaultMessage: 'Remove {email} from student roster?',
    },
});
